import type { Failure } from "@/modules/shared/failure";
import { SYSTEM_ERROR } from "@/modules/shared/forms";
import { REVIEW_COPY } from "../domain/reviewForm";

/**
 * The **web's** copy for every code the submit core can refuse with (R22 T7).
 *
 * Lifted out of `./submit.ts` for the reason every other copy map was: that
 * file is `"use server"`, where every export must be an async function, so a
 * pure lookup could neither be exported nor unit-tested there. Every sentence
 * is unchanged.
 */
export function reviewsCopyFor(failure: Failure): string {
  switch (failure.code) {
    case "not_found":
      return "This booking could not be found.";
    case "review_not_unlocked":
      return "You can leave a review 15 minutes after the appointment ends.";
    case "already_reviewed":
      return "You've already reviewed this booking.";
    case "malformed_input":
    case "rating_required":
    case "review_body_too_long":
      // One wording for one rule: REVIEW_COPY is shared with every surface that
      // renders these, so a copy edit lands everywhere at once.
      return REVIEW_COPY[failure.code];
    default:
      return SYSTEM_ERROR;
  }
}
